import React from 'react';
import { TextField, Typography, makeStyles } from '@material-ui/core';
import cx from 'classnames';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '-webkit-fill-available',
    padding: '16px 18px',
    display: 'flex',
    alignItems: 'center',
    borderBottom: '1px solid',
    borderColor: (props: StylesProps) => props.color,
    '& input': {
        color: (props: StylesProps) => props.color,
    },
    [theme.breakpoints.down('xs')]: {
      padding: '10px 0',
      height: 20,
    }
  },
  label: {
    maxWidth: 160,
    flex: 1,
    textAlign: 'left',
    marginRight: theme.spacing(2),
    color: (props: StylesProps) => props.color,
    [theme.breakpoints.down('xs')]: {
      maxWidth: 100,
    }
  },
  input: {
    flex: 1,
    '& .MuiFormHelperText-root.Mui-error': {
        color: (props: StylesProps) => props.errorTextColor 
    },
  },
}));

interface LabeledInputProps {
  value: string;
  onChange: (v: string) => void; 
  color?: string; 
  style?: React.CSSProperties;
	className?: string;
  label: string;
  placeholder?: string;
  onBlur?: (v: string) => void;
  errorText?: string;
  errorTextColor?: string;
  autoComplete?: string;
}

interface StylesProps {
	color: string;
  errorTextColor: string;
}

const LabeledInput: React.FC<LabeledInputProps> = ({
  onChange, onBlur, 
  label, placeholder, value, errorText,
  color = 'var(--color-white)',
  errorTextColor = 'var(--color-white)',
  style, className, autoComplete
}) => {
  const classes = useStyles({ color, errorTextColor });

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange(e.target.value);
  };
  const handleBlur = (e: React.FocusEvent<HTMLInputElement>) => {
    if (!onBlur) return;
    onBlur(e.target.value);
  };

  return (
    <div className={cx(classes.root, className)} style={style}>
      <Typography variant="body1" className={classes.label}>
        {label}
      </Typography>
      <TextField
        error={!!errorText}
        helperText={errorText}
        value={value}
        onChange={handleChange}
        onBlur={handleBlur}
        variant="standard"
        fullWidth
        placeholder={ placeholder }
        className={classes.input}
        InputProps={{
          disableUnderline: true,
        }}
        autoComplete={autoComplete}
      />
    </div>
  );
};

export default LabeledInput;
